var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('forms-list-component',{attrs:{"ui":_vm.ui}})}
var staticRenderFns = []

export { render, staticRenderFns }